import React from "react";
import { Link } from "react-router-dom";

const CardHome = ({ id, titolo, descrizione, link, badge, last }) => {
  //badge = (badge >1 ) ? badge : 0;

  //console.log(titolo + " " + last);

  const lunghezza = last !== true ? "col-12 col-lg-6" : "col-12 col-lg-12";

  return (
    <div className={lunghezza} key={id}>
      <div className="card-wrapper card-space cardCustom">
        <div className="card card-bg no-after roundedCustom p-2 roundedCard">
          <div className="card-body">
            <div className="row pl-1">
              <h5 className="card-title big-heading">{titolo}</h5>
            </div>
            <div className="row">{descrizione}</div>
            <div className="it-card-footer">
              {badge && badge > 0 ? (
                <span>
                  <span
                    className="badge p-2"
                    style={{ backgroundColor: "#2e58a6" }}
                  >
                    <a className="text-white"> {badge} </a>
                  </span>{" "}
                  {badge > 1 ? <b> Notifiche</b> : <b> Notifica</b>}
                </span>
              ) : (
                <span></span>
              )}

              <Link
                to={link}
                className="btn btn-outline-primary text-decoration-none"
              >
                Visualizza
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardHome;
